import { useEffect, useRef, useState } from "react";
import { Navigate } from "react-router-dom";

const DESTINATIONS = {
  "spiral-protocol": "/cage-system?utm_source=book&utm_medium=referral&utm_campaign=spiral-protocol",
  "state-filter": "/cage-system?utm_source=book&utm_medium=referral&utm_campaign=state-filter",
  "size-lock": "/cage-system?utm_source=book&utm_medium=referral&utm_campaign=size-lock",
  "consistency-ledger": "/cage-system?utm_source=book&utm_medium=referral&utm_campaign=consistency-ledger",
  "notify": "/cage-system",
};

export default function BookLinkRedirect({ slug }) {
  const firedRef = useRef(false);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (firedRef.current) return;
    firedRef.current = true;
    // Mark this session as having arrived through an in-book redirect (BOOK bucket).
    try {
      sessionStorage.setItem("bt_cage_from_book", JSON.stringify({ t: Date.now() }));
    } catch (e) {
      // ignore — the printed link must never break because of a storage error
    }
    if (typeof navigator !== "undefined" && navigator.sendBeacon) {
      try {
        const blob = new Blob([JSON.stringify({ slug })], { type: "application/json" });
        navigator.sendBeacon("/api/bl-nav", blob);
      } catch (e) {
        // ignore any error — the printed link must never break because of logging
      }
    }
    setReady(true);
  }, [slug]);

  if (!ready) return null;
  return <Navigate to={DESTINATIONS[slug]} replace />;
}
